import ajax from '../ajax'


// 账户明细
///api/bank/account
export function  ERPBankApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/account',
        params
    })
}






// 账户明细  /api/bank/index

export function  ERPIndexApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/index',
        params
    })
}

///api/bank/save  post 添加或者修改账户 id name is_active 1有效 2无效
export function  ERPSaveApi(data) {
    return ajax({
        method:'post',
        url: 'api/bank/save',
        data
    })
}






// /api/bank/currency   账户列表
export function  ERPCurrencyApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/currency',
        params
    })
}

export function  ERPSavecurrencyApi(data) {
    return ajax({
        method:'post',
        url: 'api/bank/savecurrency',
        data
    })
}


//转移明细  /api/bank/transfer
export function  ERPTransferApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/transfer',
        params
    })
}


///api/bank/search
export function  ERPSearchApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/search',
        params
    })
}
///api/bank/transferinfo
export function  ERPTransferinfoApi(params) {
    return ajax({
        method:'get',
        url: 'api/bank/transferinfo',
        params
    })
}


///api/bank/transfersave
export function  ERPTransfersaveApi(data) {
    return ajax({
        method:'post',
        url: 'api/bank/transfersave',
        data
    })
}


///api/bank/transferdel
export function  ERPTransferdelApi(data) {
    return ajax({
        method:'post',
        url: 'api/bank/transferdel',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/bank/Account_details.js